import baseReducer from "./reducers";
import { configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { routerMiddleware } from "connected-react-router";
import storage from "redux-persist/lib/storage";
import { createBrowserHistory } from "history";
import thunk from "redux-thunk";

export const history = createBrowserHistory();

export const getStore = (reducers, persistStoreKey) => {
  const persistConfig = {
    key: persistStoreKey,
    stateReconciler: autoMergeLevel2,
    storage,
    whiteList: ["layout", "session"],
  };

  const persistedReducer = persistReducer(persistConfig, baseReducer(history, reducers));
  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
          ignoredActionPaths: ["payload.t"],
        },
      }).concat(thunk, routerMiddleware(history)),
  });

  const persistor = persistStore(store);

  return { store, persistor };
};
